import axios from "axios";

const baseURL = process.env.REACT_APP_FETCH_API;

const http = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json'
  },
});

export default http;